// extracted by mini-css-extract-plugin
export default {"container":"JobListPage_container__xZqWh","section-list":"JobListPage_section-list__BwApp","section_header":"JobListPage_section_header__aTr+L"};